import { Result, Ok } from '@/classes'
import { fetchAPI } from '@/utils/useAPI'
import { PurchasesStoreTransaction } from '@revenuecat/purchases-capacitor'

export const storeBoostPurchaseAPI = async (
	boostId: 'boost_1' | 'boost_5' | 'boost_15' | 'free',
  options?: {
    transaction?: PurchasesStoreTransaction
  }
) => {
	const response: Result<{ success: boolean }> = await fetchAPI('store/boost', {
		boostId, options
	}, { method: 'POST' })
	
	return response
}


export const storeBoostUseAPI = async () => {
	const response: Result<{ success: boolean }> = await fetchAPI('store/boost/use', {}, { method: 'POST' })
	
	return response
}

export const storeCodeAPI = async (code: string) => {
	const response: Result<{
		success: boolean
	}> = await fetchAPI('store/code', { code }, {
    method: 'POST'
  })

	return response
}